import dateTimeHelper from './datetimeHelper';
import mathHelper from './mathHelper';

export default class stringHelper {
  static toBracket(value) {
    return ` (${value}) `;
  }

  // A name followed by its id in brackets, the way the survey selects list a survey: "Name (1234)". A missing name
  // leaves "(1234)", a missing id the name alone.
  static toNameWithBracketedId(name, id) {
    if (stringHelper.isEmpty(id)) {
      return stringHelper.nullToEmptyString(name);
    }
    return stringHelper.isEmpty(name) ? `(${id})` : `${name} (${id})`;
  }

  static isEmpty(value) {
    return value === '' || value === null || value === undefined;
  }

  static convertToWords(text) {
    if (!text) return '';
    const result = text.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  static convertUnicode(input) {
    return input.replace(/\\u[0-9a-fA-F]{4}/g, (a, b) => {
      const charcode = parseInt(b, 16);
      return String.fromCharCode(charcode);
    });
  }

  static ordinalNumber(number) {
    const tenresidual = number % 100;
    const hundredresidual = number % 100;

    if (hundredresidual === 11) return `${number}th`;
    if (hundredresidual === 12) return `${number}th`;
    if (tenresidual === 1) return `${number}st`;
    if (tenresidual === 2) return `${number}nd`;

    return `${number}th`;
  }

  static numberWithLetter(number, firstLetterUppercase = false) {
    const numbers = [
      'zero',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
    ];
    if (number === undefined || number === null) return '';

    if (numbers[number]) {
      const result = numbers[number];
      return firstLetterUppercase ? stringHelper.firstLetterToUpperCase(result) : result;
    }
    return number.toString();
  }

  static firstLetterToUpperCase(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  static nameCleaning(name) {
    return name.replaceAll(/[^a-zA-Z]/g, '');
  }

  static GenerateNewPassword(
    numberOfLettersLowerCase = 4,
    numberOfLettersUpperCase = 1,
    numberOfNums = 2,
    numberOfSpec = 1
  ) {
    const letters = 'qwertzuiopasdfghjklyxcvbnm';
    const numbers = '0123456789';
    const spec = '§+!%/=()<>#&@{}.,;-_*$';
    let pass = '';
    let index = 0;
    for (index = 0; index < numberOfLettersLowerCase; index++) {
      pass += letters.toLowerCase().substr(mathHelper.RandomInt(letters.length), 1);
    }
    for (index = 0; index < numberOfLettersUpperCase; index++) {
      pass += letters.toUpperCase().substr(mathHelper.RandomInt(letters.length), 1);
    }
    for (index = 0; index < numberOfNums; index++) {
      pass += numbers.substr(mathHelper.RandomInt(numbers.length), 1);
    }
    for (index = 0; index < numberOfSpec; index++) {
      pass += spec.substr(mathHelper.RandomInt(spec.length), 1);
    }

    pass = stringHelper.shuffle(pass);

    return pass;
  }

  static CheckPasswordComplexity(password, minLow = 6, minUp = 1, minNum = 3, minSpec = 1) {
    const numUpper = password.length - password.replace(/[A-Z]/g, '').length;
    const numLower = password.length - password.replace(/[a-z]/g, '').length;
    const numNumeric = password.length - password.replace(/[0-9]/g, '').length;
    const numSpec = password.length - password.replace(/[^A-Za-z0-9]/g, '').length;
    return numUpper >= minUp && numLower >= minLow && numNumeric >= minNum && numSpec >= minSpec;
  }

  static shuffle(str) {
    const a = str.split('');
    const n = a.length;

    for (let i = n - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const tmp = a[i];
      a[i] = a[j];
      a[j] = tmp;
    }
    return a.join('');
  }

  static plural(number, word, pluralWord, firstLetterUppercase = false, have = false) {
    let result = `${stringHelper.numberWithLetter(number, firstLetterUppercase)} ${
      number > 1 ? (pluralWord ? pluralWord : `${word}s`) : word
    }`;
    if (have) {
      result += ` ${number > 1 ? 'have' : 'has'}`;
    }
    return result;
  }

  static nullToEmptyString(value) {
    if (value) return value;
    return '';
  }

  static removeTrailingZeros(value) {
    if (!value || value === 0 || value === '0') return '0';

    const parts = value.toString().split('.');
    const intPart = parseInt(parts[0]);
    if (parts.length === 1) {
      return intPart.toString();
    }
    let decimalPart = parts[1];

    decimalPart = value.toString().split('.')[1].substring(0, 2);

    return `${intPart}.${decimalPart}`;
  }

  static getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
  }

  static updateSearchParams(searchParams) {
    if (window.location.pathname.split('/')[2] !== 'search') {
      return;
    }
    const keys = Object.getOwnPropertyNames(searchParams);
    const urlParams = new URLSearchParams(window.location.search);

    keys.forEach((key) => {
      if (key === 'UrlModifiableParams') return;
      if (urlParams.get(key) === '' && !searchParams[key] !== urlParams.get(key)) {
        searchParams[key] = urlParams.get(key);
      } else if (urlParams.get(key) && !searchParams[key]) {
        searchParams[key] = urlParams.get(key);
      } else if (Array.isArray(searchParams[key]) && urlParams.get(key)) {
        searchParams[key] = urlParams.get(key).split(',');
      } else if (urlParams.get(key) && dateTimeHelper.isDate(urlParams.get(key))) {
        searchParams[key] = urlParams.get(key);
      } else if (
        urlParams.get(key) &&
        keys.includes('UrlModifiableParams') &&
        searchParams['UrlModifiableParams'].includes(key)
      ) {
        searchParams[key] = urlParams.get(key);
      }
    });
  }

  static getValueWithSymbol(desc, symbol, value) {
    if (symbol === null) {
      if (value === null) {
        return '0.00';
      }
      return parseFloat(value).toFixed(2);
    } else {
      if (value === null) {
        return `${symbol} 0.00`;
      }
      return `${symbol} ${parseFloat(value).toFixed(2)}`;
    }
  }

  static getValueWithSymbolEmpty(symbol, value) {
    if (symbol === null) {
      if (value === null) {
        return '0.00';
      }
      return parseFloat(value).toFixed(2);
    }
    if (value === null) return '';
    return `${symbol} ${parseFloat(value).toFixed(2)}`;
  }

  static getFeeTotal(symbol, array) {
    return stringHelper.getValueWithSymbol('', symbol, mathHelper.Sum(array));
  }

  static numberWithLeadingZero(number) {
    number = `00${number}`;
    return number.slice(-2);
  }

  static onlyLettersAndNumbers(str) {
    return /^[A-Za-z0-9]*$/.test(str);
  }

  static addLeadingZero(number) {
    return number < 10 ? `0${number}` : number;
  }
}
